import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizationCalendarModePipe } from './pipes/localization-calendar-mode.pipe';
import { LocalizationCurrencyNoSymbolPipe } from './pipes/localization-currency-no-symbol.pipe';
import { LocalizationCurrencyPipe } from './pipes/localization-currency.pipe';
import { LocalizationDatePipe } from './pipes/localization-date.pipe';
import { LocalizationDecimalPipe } from './pipes/localization-decimal.pipe';
import { LocalizationMonthlyToWordsPipe } from './pipes/localization-monthly-to-words.pipe';
import { LocalizationPercentNoSymbolPipe } from './pipes/localization-percent-no-symbol.pipe';
import { LocalizationPercentPipe } from './pipes/localization-percent.pipe';
import { LocalizationRelativeTimePipe } from './pipes/localization-relative-time.pipe';
import { LocalizationTimePipe } from './pipes/localization-time.pipe';
import { LocalizationDateTimePipe } from './pipes/localization-date-time.pipe';

@NgModule({
    declarations: [
        LocalizationTimePipe,
        LocalizationPercentPipe,
        LocalizationDecimalPipe,
        LocalizationDatePipe,
        LocalizationDateTimePipe,
        LocalizationCurrencyPipe,
        LocalizationCurrencyNoSymbolPipe,
        LocalizationCalendarModePipe,
        LocalizationPercentNoSymbolPipe,
        LocalizationMonthlyToWordsPipe,
        LocalizationRelativeTimePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LocalizationTimePipe,
        LocalizationPercentPipe,
        LocalizationDecimalPipe,
        LocalizationDatePipe,
        LocalizationDateTimePipe,
        LocalizationCurrencyPipe,
        LocalizationCurrencyNoSymbolPipe,
        LocalizationCalendarModePipe,
        LocalizationPercentNoSymbolPipe,
        LocalizationMonthlyToWordsPipe,
        LocalizationRelativeTimePipe
    ],
    providers: [
        LocalizationTimePipe,
        LocalizationDatePipe,
        LocalizationDateTimePipe
    ]
})
export class LocalizationModule { }
